import axios from 'axios';
import { put, call } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga/effects';
import { FETCH_TEAMS_PERFORMED, TEAM_CREATE_PERFORMED, teamLoaderStatus, fetchTeamsSuccess, teamCreateSuccess, teamCreateErrors, fetchTeamsPerformed, TEAM_DELETE_PERFORMED, GET_TEAM_DETAIL, TEAM_EDIT_PERFORMED, getTeamSuccess, teamEditSuccess, teamEditErrors } from '../actions/team';
import { push } from 'connected-react-router';
import {API_BASE_URL} from '../constants';
import swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

function* fetchTeams() {
    yield put(teamLoaderStatus(true));
    try {
		let user = JSON.parse(localStorage.getItem('user'));
        let organisation_id = user.current_org;
        const results = yield call(
            axios.get,
            `${API_BASE_URL}/v1/auth/organisation/${organisation_id}/teams`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + user.access_token,
                }
            }
        );
        yield put(teamLoaderStatus(false));
		yield put(fetchTeamsSuccess(results.data.data));
    }catch (error) {
        yield put(teamLoaderStatus(false));
        if(error.response.status === 401)
        {
            localStorage.removeItem('user');
            swal(
                'Error',
                'Your session has expired.',
                'error'
            );
            yield put(push('/login'));
        }
        console.log(error);
    }
}

function* doCreateNewTeam({teamFormData}) {
	yield put(teamLoaderStatus(true));
    try {
		let user = JSON.parse(localStorage.getItem('user'));
		let organisation_id = user.current_org;
        const teamResults = yield call(
            axios.post,
            `${API_BASE_URL}/v1/auth/organisation/${organisation_id}/teams`,
            teamFormData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + user.access_token,
                }
            }
        );
        yield put(teamLoaderStatus(false));
        swal(
            'Success',
            teamResults.data.message,
            'success'
        );
        yield put(teamCreateSuccess(true));
        yield put(fetchTeamsPerformed());
    }catch (error) {
		yield put(teamLoaderStatus(false));
        if(error.response.status === 422)
        {
            yield put(teamCreateErrors(error.response.data.errors));
        }
        if(error.response.status === 409)
        {
            swal(
                'Error',
                error.response.data.message,
                'error'
            );
        }
        if(error.response.status === 401)
        {
            localStorage.removeItem('user');
            swal(
                'Error',
                'Your session has expired.',
                'error'
            );
            yield put(push('/login'));
        }
    }
}

function* doRemoveTeam({id}) {
    yield put(teamLoaderStatus(true));
    try {
        let user = JSON.parse(localStorage.getItem('user'));
        let organisation_id = user.current_org;
        const results = yield call(
            axios.delete,
            `${API_BASE_URL}/v1/auth/organisation/${organisation_id}/teams/${id}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + user.access_token,
                }
            }
        );
        yield put(teamLoaderStatus(false));
		swal(
            'Success',
            results.data.message,
            'success'
        );
        yield put(fetchTeamsPerformed());
    }catch (error) {
        yield put(teamLoaderStatus(false));
        if(error.response.status === 401)
        {
            localStorage.removeItem('user');
            swal(
                'Error',
                'Your session has expired.',
                'error'
            );
            yield put(push('/login'));
        }
        console.log(error);
    }
}

function* fetchTeamDetail({id}) {
    yield put(teamLoaderStatus(true));
    try {
		let user = JSON.parse(localStorage.getItem('user'));
		let organisation_id = user.current_org;
        const results = yield call(
            axios.get,
            `${API_BASE_URL}/v1/auth/organisation/${organisation_id}/teams/${id}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + user.access_token,
                }
            }
        );
        yield put(teamLoaderStatus(false));
		yield put(getTeamSuccess(results.data));
    }catch (error) {
        yield put(teamLoaderStatus(false));
        if(error.response.status === 401)
        {
            localStorage.removeItem('user');
            swal(
                'Error',
                'Your session has expired.',
                'error'
            );
            yield put(push('/login'));
        }
        console.log(error);
    }
}

function* doUpdateTeam({teamFormData, id}) {
	yield put(teamLoaderStatus(true));
    try {
		let user = JSON.parse(localStorage.getItem('user'));
		let organisation_id = user.current_org;
        const teamResults = yield call(
            axios.put,
            `${API_BASE_URL}/v1/auth/organisation/${organisation_id}/teams/${id}`,
            teamFormData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
					'Access-Control-Allow-Origin': '*',
					'Authorization': 'Bearer ' + user.access_token,
                }
            }
        );
        yield put(teamLoaderStatus(false));
        swal(
            'Success',
            teamResults.data.message,
            'success'
        );
        yield put(teamEditSuccess(true));
        yield put(fetchTeamsPerformed());
        
    }catch (error) {
		yield put(teamLoaderStatus(false));
        if(error.response.status === 422)
        {
            yield put(teamEditErrors(error.response.data.errors));
        }
        if(error.response.status === 401)
        {
            localStorage.removeItem('user');
            swal(
                'Error',
                'Your session has expired.',
                'error'
            );
            yield put(push('/login'));
        }
    }
}

export default function* () {
    yield takeLatest(FETCH_TEAMS_PERFORMED, fetchTeams);
    yield takeLatest(TEAM_CREATE_PERFORMED, doCreateNewTeam);
    yield takeLatest(TEAM_DELETE_PERFORMED, doRemoveTeam);
    yield takeLatest(GET_TEAM_DETAIL, fetchTeamDetail);
    yield takeLatest(TEAM_EDIT_PERFORMED, doUpdateTeam);
}